/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 15.06.24
 *
 */

export const ReminderType = Object.freeze({
	NOT_SET: 'NOT_SET',
	EMAIL: 'EMAIL',
	CALENDAR: 'CALENDAR',
})
